import { ArrowIcon, Box } from '@modusign/design-system';
import cx from 'classnames';
import { MouseEventHandler, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import previewImage from '@app/assets/modal/upload-modal/preview.svg';
import CenterLoadingSpinner from '@app/components/CenterLoadingSpinner';
import { getIsTrialPlanAppliedToday } from '@app/features/subscription/state';
import SampleFile from '@app/store/documents/SampleFile';

import './UpLoadModalSampleDocuments.scss';

interface UpLoadModalSampleDocumentsProps {
  isLoading: boolean;
  sampleFileList: SampleFile[];
  onSelect: MouseEventHandler;
  onSampleDocumentSelect: (url: string, name: string) => void;
}

function UpLoadModalSampleDocuments({
  isLoading,
  sampleFileList,
  onSelect,
  onSampleDocumentSelect,
}: UpLoadModalSampleDocumentsProps) {
  const isTrialPlanAppliedToday = useSelector(getIsTrialPlanAppliedToday);
  const [selectedDocument, setSelectedDocument] = useState('');

  useEffect(() => {
    if (sampleFileList[0] && isTrialPlanAppliedToday) {
      setSelectedDocument(sampleFileList[0].name);
      onSampleDocumentSelect(sampleFileList[0].url, sampleFileList[0].name);
    }
  }, [sampleFileList, onSampleDocumentSelect, isTrialPlanAppliedToday]);

  const handleClick = useCallback(
    async (document) => {
      setSelectedDocument(document.name);
      onSampleDocumentSelect(document.url, document.name);
    },
    [onSampleDocumentSelect]
  );

  return (
    <ul className="UpLoadModalSampleDocuments__wrapper">
      <li className="UpLoadModalSampleDocuments__title UpLoadModalSampleDocuments__title--upload">
        <button className="TextBtn" name={'LOCAL'} type="button" onClick={onSelect}>
          내 컴퓨터에서 업로드 <ArrowIcon direction="right" ml="2px" />
        </button>
      </li>
      {isLoading && (
        <Box height="300px" position="relative">
          <CenterLoadingSpinner />
        </Box>
      )}
      {sampleFileList.map((document) => (
        <li
          className={cx('UpLoadModalSampleDocuments__title', {
            'UpLoadModalSampleDocuments__title--active': selectedDocument === document.name,
          })}
          key={document.name}
        >
          <button
            className="UpLoadModalSampleDocuments__button"
            type="button"
            onClick={() => handleClick(document)}
          >
            <i
              className={cx('UpLoadModalSampleDocuments__title--icon', 'fa', {
                'fa-check': selectedDocument === document.name,
                'UpLoadModalSampleDocuments__title--active-icon':
                  selectedDocument === document.name,
                'fa-file-o': selectedDocument !== document.name,
              })}
            />
            {document.name}
          </button>
          <a
            className="UpLoadModalSampleDocuments__title--preview-icon"
            href={document.url || ''}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="preview" src={previewImage} />
          </a>
        </li>
      ))}
    </ul>
  );
}

export default UpLoadModalSampleDocuments;
